import { Input, input, KeyCode, Node } from 'cc';
import Model from '../../../../../common/scripts/Toolkit/Helper/Model';
import TableGame from '../../../System/TableGame';
import DataType from '../Config/DataStructure';

enum NodeName {
    Debugger = 'Debugger',
}

export default class DebugModel extends Model {
    protected _enabled: boolean = false;
    protected _debugData: DataType.Bet.DebugData = {};

    constructor() {
        super();
        let debuggerNode: Node;
        input.on(Input.EventType.KEY_UP, (event) => {
            if (event.keyCode === KeyCode.BACK_QUOTE) {
                if (!debuggerNode) {
                    debuggerNode = TableGame.scene.getNode(NodeName.Debugger);
                } else {
                    debuggerNode.active = !debuggerNode.active;
                }
            }
        });
    }

    public get debugData(): DataType.Bet.DebugData {
        return this._debugData;
    }

    public get enabled(): boolean {
        return this._enabled;
    }
    public set enabled(value: boolean) {
        if (value === this._enabled) {
            return;
        }
        this._enabled = value;
    }

    public init() {}
}
